import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from './search.component';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { StationBadgeModule } from 'shared/badges/station-badge/station-badge.module';

import { StationsServiceModule } from 'shared/stations-service/stations.module';
import { ConnectorBadgeModule } from 'shared/badges/connector-badge/connector-badge.module';
import { TicketBadgeModule } from 'shared/badges/ticket-badge/ticket-badge.module';
import { LocationBadgeModule } from 'shared/badges/location-badge/location-badge.module';
import { SearchApiModule } from '@kempoweroyj/ngx-search-api-client';
import { PopupModule } from 'shared/popup-service/popup.module';
import { OrganizationBadgeModule } from 'shared/badges/organization-badge/organization-badge.module';

@NgModule({
    declarations: [SearchComponent],
    imports: [
        CommonModule,
        MatInputModule,
        MatAutocompleteModule,
        MatIconModule,
        StationBadgeModule,
        FormsModule,
        StationsServiceModule,
        ConnectorBadgeModule,
        TicketBadgeModule,
        OrganizationBadgeModule,
        LocationBadgeModule,
        SearchApiModule,
        PopupModule,
    ],
    exports: [SearchComponent],
})
export class SearchModule {}
